/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Status_SyncingInputs */



/**
* | output |
* | --- |
* | "Applying automatic sync..." |
*
* @param {Offline_Sync_Status_SyncingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_status_syncing = /** @type {((inputs?: Offline_Sync_Status_SyncingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Status_SyncingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Application de la synchronisation automatique...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Synchronisierung wird angewendet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicazione sincronizzazione automatica...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применение автоматической синхронизации...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicando sincronización automática...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在应用自动同步...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動同期を適用しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित सिंक लागू किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A aplicar sincronização automática...")
	return /** @type {LocalizedString} */ ("Applying automatic sync...")
});